// @flow
import * as React from 'react';
import { PropsWithChildren } from 'react';
import { Box, SxProps, Typography } from '@mui/material';

export const NoData = ({sx = {}, height = 150, children}: PropsWithChildren<{sx?: SxProps, height?: number}>) => (
  <Box sx={{minHeight: height, display: 'flex', alignItems: 'center', justifyContent: 'center', flex: 1, ...sx}}>
    <Typography color={'#a5a5a5'} variant={'body2'}>{children || 'No data'}</Typography>
  </Box>
)
